<template>
  <RouterLink
    :to="{
      query: {
        type: value
      }
    }"
    class="item-con"
    :data-cy="`report-link-item-${value}`"
  >
    <div class="title">
      {{ title }}
    </div>
    <div class="gen">
      <div class="icon">
        <v-icon size="large" color="primary">mdi-file-document-arrow-right-outline</v-icon>
      </div>
      <div class="text">Generate Report</div>
    </div>
  </RouterLink>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  value: string;
}>();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.item-con {
  width: calc(33% - 13px);
  min-width: min(100%, 350px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: white;
  border: 2px solid $primary-75;
  border-radius: 16px;
  height: 200px;
  color: none;
  text-decoration: none;
  gap: 30px;

  .title {
    color: $gray-800;
    font-weight: 600;
    font-size: 1.25rem;
  }
  .gen {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    .text {
      font-weight: 600;
      text-transform: uppercase;
      font-size: 0.875rem;
      color: $primary;
    }
  }
}
</style>
